import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { MenuInterface } from 'app/module/menu-interface';
import { CoreMenu } from '@core/types';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class MenuService {
	private url: string = environment.g2e_api;

	constructor(private http: HttpClient) { }

	public get(): Observable<any> {
		// Headers montados a cada chamada: o token nao existe antes do login, entao um header
		// fixado no construtor ficaria "Bearer null" ate a pagina ser recarregada.
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json; charset=UTF-8',
				'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
			}),
		};
		return this.http.get(`${this.url}menu`, httpOptions).pipe(
			tap(response => {
				return response;
			}),
			catchError(error => {
				console.error("❌ Erro ao buscar menus:", error);
				return throwError(error);
			})
		);
	}


	// get(): Observable<{ data: CoreMenu[] }> {
	// 	return this.http.get<{ data: CoreMenu[] }>(`${this.url}menu`, this.httpOptions);
	// }


}
